export default __webpack_public_path__ + "static/media/bonsai.5da9c25d.png";